export const API_PREFIX = '/api';

export type RouteSegment = string | ((param: string) => string);

export type RouteSegments = Record<string, RouteSegment>;

// Полный клиентский путь повторяет форму сегмента: строка остаётся строкой, билдер остаётся билдером.
export type ApiRoutes<S extends RouteSegments> = {
  readonly [K in keyof S]: S[K] extends (param: string) => string ? (param: string) => string : string;
};

export interface RouteGroup<P extends string, S extends RouteSegments> {
  /** Аргумент `@Controller(...)`; пустая строка — контроллер без префикса. */
  readonly prefix: P;
  /** Аргументы `@Get/@Post/...` относительно префикса; билдер принимает `':id'` на бэке и живой id на фронте. */
  readonly segments: S;
  /** Полные пути для HttpClient: `/api/<prefix>/<segment>`. */
  readonly api: ApiRoutes<S>;
}

export const joinPath = (...parts: string[]): string => parts.filter(part => part !== '').join('/');

export function defineRouteGroup<P extends string, const S extends RouteSegments>(prefix: P, segments: S): RouteGroup<P, S> {
  const api = Object.fromEntries(
    Object.entries(segments).map(([key, segment]) => [
      key,
      typeof segment === 'function'
        ? (param: string) => `${API_PREFIX}/${joinPath(prefix, segment(param))}`
        : `${API_PREFIX}/${joinPath(prefix, segment)}`,
    ]),
  ) as ApiRoutes<S>;
  return { prefix, segments, api };
}
